<template>
  <div id="dkkk" class="fontthai bg">
    <!-- <pre>{{ value }}</pre> -->
    <vs-row>
      <vs-spacer />
      <vs-button
        radius
        color="success"
        class="mr-2"
        @click="printmodal"
        type="flat"
        icon="print"
      ></vs-button
    ></vs-row>
    <div id="printHere">
      <div class="div_row">
        <div class="div_p">
          <h3 class="colorgray">Customer Satisfaction Form</h3>
        </div>
      </div>
      <br />
      <div class="div_row">
        <div class="div_p">
          <div class="div_card">
            <br />
            <b><h4>ข้อมูลผู้กรอก</h4></b>
            <div class="div_row_detail mt-3">
              <div class="item_row div_item1">
                <a class="nowrap">ชื่อบริษัท : </a>
                <vs-input
                  class="ml-2"
                  :danger="valid.company"
                  style="width: 100%; color: #000"
                  danger-text="กรุณากรอกชื่อบริษัท"
                  v-model="value.company"
                />
              </div>
              <div class="item_row div_item2">
                <a class="nowrap"> แผนก : </a>
                <vs-input
                  class="ml-2"
                  :danger="valid.department"
                  danger-text="กรุณากรอกแผนก"
                  style="width: 100%; color: #000"
                  v-model="value.department"
                />
              </div>
              <div class="item_row div_item3">
                <a class="nowrap">
                  <vs-icon
                    :class="valid.agency"
                    icon="error_outline"
                    color="red"
                  ></vs-icon>

                  หน่วยงาน :
                </a>
                <vs-radio
                  class="ml-2 mt-2"
                  v-model="value.agency"
                  vs-name="radios_agency"
                  vs-value="1"
                  >รัฐ</vs-radio
                >
                <vs-radio
                  class="ml-4 mt-2"
                  v-model="value.agency"
                  vs-name="radios_agency"
                  vs-value="2"
                  >เอกชน</vs-radio
                >
              </div>
            </div>
            <div class="div_row_detail margin_top">
              <div class="item_row div_item4">
                <a class="nowrap">
                  <vs-icon
                    :class="valid.gender"
                    icon="error_outline"
                    color="red"
                  ></vs-icon
                  >เพศ :
                </a>
                <vs-radio
                  class="ml-2 mt-2"
                  v-model="value.gender"
                  vs-name="radios_gender"
                  vs-value="M"
                  >ชาย</vs-radio
                >
                <vs-radio
                  class="ml-4 mt-2"
                  v-model="value.gender"
                  vs-name="radios_gender"
                  vs-value="F"
                  >หญิง</vs-radio
                >
              </div>
              <div class="item_row div_item5">
                <vs-icon
                  :class="valid.age"
                  icon="error_outline"
                  color="red"
                ></vs-icon>
                อายุ :
                <vs-radio
                  class="ml-2 mt-2"
                  v-model="value.age"
                  vs-name="radios_age"
                  vs-value="1"
                  >ต่ำกว่า 19 </vs-radio
                ><vs-radio
                  class="ml-4 mt-2"
                  v-model="value.age"
                  vs-name="radios_age"
                  vs-value="2"
                  >20-29 ปี </vs-radio
                ><vs-radio
                  class="ml-4 mt-2"
                  v-model="value.age"
                  vs-name="radios_age"
                  vs-value="3"
                  >30-39 ปี</vs-radio
                >
                <vs-radio
                  class="ml-4 mt-2"
                  v-model="value.age"
                  vs-name="radios_age"
                  vs-value="4"
                  >40-49 ปี</vs-radio
                >
                <vs-radio
                  class="ml-4 mt-2"
                  v-model="value.age"
                  vs-name="radios_age"
                  vs-value="5"
                  >มากกว่า 50 ปี
                </vs-radio>
              </div>
            </div>
            <br />
          </div>
        </div>
      </div>
      <br />
      <div class="div_row">
        <div class="div_p">
          <div class="div_card">
            <br />
            <b><h4>ความพึงพอใจในการใช้บริการ Sentenance</h4></b> <br />
            <div class="div_row">
              <div class="div_p text_right colorgray">
                <a
                  >(5 = มากที่สุด , 4= มาก , 3 = ปานกลาง , 2= น้อย , 1=
                  น้อยที่สุด)</a
                >
              </div>
            </div>
            <div class="div_ptable">
              <vs-table hoverFlat="False" :data="data[0]">
                <template slot="header">
                  <b><h4>ตอนที่ 1 ด้านการบริการของเจ้าหน้าที่</h4></b>
                </template>
                <template align="center" slot="thead">
                  <vs-th class="width45"> </vs-th>
                  <vs-th v-for="i in number" :key="i">
                    <div class="num_center">{{ i }}</div>
                  </vs-th>
                </template>

                <template slot-scope="{ data }">
                  <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                    <vs-td :data="data[indextr].name">
                      <h6>
                        <vs-icon
                          :class="valid.items1['a' + indextr]"
                          icon="error_outline"
                          color="red"
                        ></vs-icon>
                        {{ data[indextr].name }}
                      </h6>
                    </vs-td>

                    <vs-td align="center" :data="data[indextr].key">
                      <vs-radio
                        v-model="value.items1['a' + indextr]"
                        :vs-name="'radios_items1_' + [indextr]"
                        vs-value="5"
                      />
                    </vs-td>

                    <vs-td :data="data[indextr].key">
                      <vs-radio
                        v-model="value.items1['a' + indextr]"
                        :vs-name="'radios_items1_' + [indextr]"
                        vs-value="4"
                      />
                    </vs-td>

                    <vs-td :data="data[indextr].key">
                      <vs-radio
                        v-model="value.items1['a' + indextr]"
                        :vs-name="'radios_items1_' + [indextr]"
                        vs-value="3"
                      />
                    </vs-td>
                    <vs-td :data="data[indextr].key">
                      <vs-radio
                        v-model="value.items1['a' + indextr]"
                        :vs-name="'radios_items1_' + [indextr]"
                        vs-value="2"
                      />
                    </vs-td>

                    <vs-td :data="data[indextr].key">
                      <vs-radio
                        v-model="value.items1['a' + indextr]"
                        :vs-name="'radios_items1_' + [indextr]"
                        vs-value="1"
                      />
                    </vs-td>
                  </vs-tr>
                </template> </vs-table
              ><br /><br />
              <vs-table hoverFlat="False" :data="data[1]">
                <template slot="header">
                  <b><h4>ตอนที่ 2 ด้านการบริการ Sentenance Platform</h4></b>
                </template>
                <template align="center" slot="thead">
                  <vs-th class="width45"> </vs-th>
                  <vs-th v-for="i in number" :key="i">
                    <div class="num_center">{{ i }}</div>
                  </vs-th>
                </template>

                <template slot-scope="{ data }">
                  <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                    <vs-td :data="data[indextr].name">
                      <h6>
                        <vs-icon
                          :class="valid.items2['a' + indextr]"
                          icon="error_outline"
                          color="red"
                        ></vs-icon
                        >{{ data[indextr].name }}
                      </h6>
                    </vs-td>

                    <vs-td align="center" :data="data[indextr].key">
                      <vs-radio
                        v-model="value.items2['a' + indextr]"
                        :vs-name="'radios_items2_' + [indextr]"
                        vs-value="5"
                      />
                    </vs-td>

                    <vs-td :data="data[indextr].key">
                      <vs-radio
                        v-model="value.items2['a' + indextr]"
                        :vs-name="'radios_items2_' + [indextr]"
                        vs-value="4"
                      />
                    </vs-td>

                    <vs-td :data="data[indextr].key">
                      <vs-radio
                        v-model="value.items2['a' + indextr]"
                        :vs-name="'radios_items2_' + [indextr]"
                        vs-value="3"
                      />
                    </vs-td>
                    <vs-td :data="data[indextr].key">
                      <vs-radio
                        v-model="value.items2['a' + indextr]"
                        :vs-name="'radios_items2_' + [indextr]"
                        vs-value="2"
                      />
                    </vs-td>

                    <vs-td :data="data[indextr].key">
                      <vs-radio
                        v-model="value.items2['a' + indextr]"
                        :vs-name="'radios_items2_' + [indextr]"
                        vs-value="1"
                      />
                    </vs-td>
                  </vs-tr>
                </template>
              </vs-table>
              <br /><br />
              <vs-table hoverFlat="False" :data="data[2]">
                <template slot="header">
                  <b
                    ><h4>
                      ตอนที่ 3 ด้านการบริการการติดตั้ง และการใช้งาน Hardware
                    </h4></b
                  >
                </template>
                <template align="center" slot="thead">
                  <vs-th class="width45"> </vs-th>
                  <vs-th v-for="i in number" :key="i">
                    <div class="num_center">{{ i }}</div>
                  </vs-th>
                </template>

                <template slot-scope="{ data }">
                  <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                    <vs-td :data="data[indextr].name">
                      <h6>
                        <vs-icon
                          :class="valid.items3['a' + indextr]"
                          icon="error_outline"
                          color="red"
                        ></vs-icon
                        >{{ data[indextr].name }}
                      </h6>
                    </vs-td>

                    <vs-td align="center" :data="data[indextr].key">
                      <vs-radio
                        v-model="value.items3['a' + indextr]"
                        :vs-name="'radios_items3_' + [indextr]"
                        vs-value="5"
                      />
                    </vs-td>

                    <vs-td :data="data[indextr].key">
                      <vs-radio
                        v-model="value.items3['a' + indextr]"
                        :vs-name="'radios_items3_' + [indextr]"
                        vs-value="4"
                      />
                    </vs-td>

                    <vs-td :data="data[indextr].key">
                      <vs-radio
                        v-model="value.items3['a' + indextr]"
                        :vs-name="'radios_items3_' + [indextr]"
                        vs-value="3"
                      />
                    </vs-td>
                    <vs-td :data="data[indextr].key">
                      <vs-radio
                        v-model="value.items3['a' + indextr]"
                        :vs-name="'radios_items3_' + [indextr]"
                        vs-value="2"
                      />
                    </vs-td>

                    <vs-td :data="data[indextr].key">
                      <vs-radio
                        v-model="value.items3['a' + indextr]"
                        :vs-name="'radios_items3_' + [indextr]"
                        vs-value="1"
                      />
                    </vs-td>
                  </vs-tr>
                </template>
              </vs-table>
              <br /><br />
              <vs-table hoverFlat="False" :data="data[3]">
                <template slot="header">
                  <b><h4>ตอนที่ 4 ภาพรวมของ Solution</h4></b>
                </template>
                <template align="center" slot="thead">
                  <vs-th class="width45"> </vs-th>
                  <vs-th v-for="i in number" :key="i">
                    <div class="num_center">{{ i }}</div>
                  </vs-th>
                </template>
                <template slot-scope="{ data }">
                  <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                    <vs-td :data="data[indextr].name">
                      <h6>
                        <vs-icon
                          :class="valid.items4['a' + indextr]"
                          icon="error_outline"
                          color="red"
                        ></vs-icon
                        >{{ data[indextr].name }}
                      </h6>
                    </vs-td>

                    <vs-td align="center" :data="data[indextr].key">
                      <vs-radio
                        v-model="value.items4['a' + indextr]"
                        :vs-name="'radios_items4_' + [indextr]"
                        vs-value="5"
                      />
                    </vs-td>

                    <vs-td :data="data[indextr].key">
                      <vs-radio
                        v-model="value.items4['a' + indextr]"
                        :vs-name="'radios_items4_' + [indextr]"
                        vs-value="4"
                      />
                    </vs-td>

                    <vs-td :data="data[indextr].key">
                      <vs-radio
                        v-model="value.items4['a' + indextr]"
                        :vs-name="'radios_items4_' + [indextr]"
                        vs-value="3"
                      />
                    </vs-td>
                    <vs-td :data="data[indextr].key">
                      <vs-radio
                        v-model="value.items4['a' + indextr]"
                        :vs-name="'radios_items4_' + [indextr]"
                        vs-value="2"
                      />
                    </vs-td>

                    <vs-td :data="data[indextr].key">
                      <vs-radio
                        v-model="value.items4['a' + indextr]"
                        :vs-name="'radios_items4_' + [indextr]"
                        vs-value="1"
                      />
                    </vs-td>
                  </vs-tr>
                </template>
              </vs-table>
              <div class="mt-4">
                <label for="story"
                  ><vs-icon
                    :class="valid.note"
                    icon="error_outline"
                    color="red"
                  ></vs-icon
                  >ข้อเสนอแนะ :</label
                ><br />
                <textarea
                  class="valid_text_show"
                  height="200px"
                  v-model="value.note"
                />
              </div>
            </div>
            <br />
            <div class="div_row">
              <div class="num_center">
                <vs-button
                  color="success"
                  @click="submit_value(value)"
                  class="btnwidth"
                  type="filled"
                  >Submit</vs-button
                ><vs-button class="ml-3 btnwidth" color="dark" type="filled"
                  >Clear</vs-button
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data: () => ({
    number: [5, 4, 3, 2, 1],
    data: [
      [
        {
          key: 1,
          name: "ดูแลเอาใจใส่ เต็มใจให้บริการ",
          value: null,
        },
        {
          key: 2,
          name: "เจ้าหน้าที่ให้บริการด้วยความสุภาพเป็นมิตร",
          value: null,
        },
        {
          key: 3,
          name: "เจ้าหน้าที่ติดต่อกลับทุกครั้งที่แจ้งการใช้บริการ",
          value: null,
        },
        {
          key: 4,
          name: "ข้อมูลที่ได้รับมีความชัดเจน ถูกต้อง และเข้าใจง่าย",
          value: null,
        },
      ],
      [
        {
          key: 1,
          name: "ระยะเวลาในการพัฒนา",
          value: null,
        },
        {
          key: 2,
          name: "ระยะเวลาในการแก้ปัญหา",
          value: null,
        },
        {
          key: 3,
          name: "ความเสถียรในการใช้งานของระบบ",
          value: null,
        },
        {
          key: 4,
          name: "ความถูกต้องของข้อมูลที่แสดงผล",
          value: null,
        },
        {
          key: 5,
          name: "ความชัดเจนของข้อมูลที่แสดงผล",
          value: null,
        },
        {
          key: 6,
          name: "ความแม่นยำ และประสิทธิภาพในการใช้งาน",
          value: null,
        },
        {
          key: 7,
          name: "ความประทับใจในการใช้งานโดยรวม",
          value: null,
        },
      ],
      [
        {
          key: 1,
          name: "ความเรียบร้อยในการติดตั้งและความสวยงาม",
          value: null,
        },
        {
          key: 2,
          name: "ความง่ายในการติดตั้ง และการใช้งาน",
          value: null,
        },
        {
          key: 3,
          name: "ความเสถียรในการส่งข้อมูล และการสั่งการ",
          value: null,
        },
        {
          key: 4,
          name: "ความประทับใจในการใช้งานโดยรวม",
          value: null,
        },
      ],
      [
        {
          key: 1,
          name: "ความประทับใจในการใช้งานโดยรวม",
          value: null,
        },
      ],
    ],
    value: {
      company: undefined,
      department: undefined,
      agency: undefined,
      gender: undefined,
      age: undefined,
      items1: { a0: undefined, a1: undefined, a2: undefined, a3: undefined },
      items2: {
        a0: undefined,
        a1: undefined,
        a2: undefined,
        a3: undefined,
        a4: undefined,
        a5: undefined,
        a6: undefined,
      },
      items3: { a0: undefined, a1: undefined, a2: undefined, a3: undefined },
      items4: { a0: undefined },
      note: undefined,
    },
    valid: {
      company: false,
      department: false,
      agency: "valid_icon_hide",
      gender: "valid_icon_hide",
      age: "valid_icon_hide",
      items1: {
        a0: "valid_icon_hide",
        a1: "valid_icon_hide",
        a2: "valid_icon_hide",
        a3: "valid_icon_hide",
      },
      items2: {
        a0: "valid_icon_hide",
        a1: "valid_icon_hide",
        a2: "valid_icon_hide",
        a3: "valid_icon_hide",
        a4: "valid_icon_hide",
        a5: "valid_icon_hide",
        a6: "valid_icon_hide",
      },
      items3: {
        a0: "valid_icon_hide",
        a1: "valid_icon_hide",
        a2: "valid_icon_hide",
        a3: "valid_icon_hide",
      },
      items4: { a0: "valid_icon_hide" },
      note: "valid_icon_hide",
    },
  }),
  methods: {
    check_valid(item) {
      console.log(item.company);
      let i =0
      console.log(item.items1["a"+i]);
      if (item.company == null || item.company.length == 0) {
        this.valid.company = true;
      } else if (item.company != null) {
        this.valid.company = false;
      }
      if (item.department == null || item.department.length == 0) {
        this.valid.department = true;
      } else if (item.department != null) {
        this.valid.department = false;
      }
      if (item.agency == null || item.agency.length == 0) {
        this.valid.agency = "valid_icon_show";
      } else if (item.agency != null) {
        this.valid.agency = "valid_icon_hide";
      }
      if (item.gender == null || item.gender.length == 0) {
        this.valid.gender = "valid_icon_show";
      } else if (item.gender != null) {
        this.valid.gender = "valid_icon_hide";
      }
      if (item.age == null || item.age.length == 0) {
        this.valid.age = "valid_icon_show";
      } else if (item.age != null) {
        this.valid.age = "valid_icon_hide";
      }
      // slot 1
      if (item.items1.a0 == null || item.items1.a0.length == 0) {
        this.valid.items1.a0 = "valid_icon_show";
      } else if (item.items1.a0 != null) {
        this.valid.items1.a0 = "valid_icon_hide";
      }
      if (item.items1.a1 == null || item.items1.a1.length == 0) {
        this.valid.items1.a1 = "valid_icon_show";
      } else if (item.items1.a1 != null) {
        this.valid.items1.a1 = "valid_icon_hide";
      }
      if (item.items1.a2 == null || item.items1.a2.length == 0) {
        this.valid.items1.a2 = "valid_icon_show";
      } else if (item.items1.a2 != null) {
        this.valid.items1.a2 = "valid_icon_hide";
      }
      if (item.items1.a3 == null || item.items1.a3.length == 0) {
        this.valid.items1.a3 = "valid_icon_show";
      } else if (item.items1.a3 != null) {
        this.valid.items1.a3 = "valid_icon_hide";
      }
      // slot 2
      if (item.items2.a0 == null || item.items2.a0.length == 0) {
        this.valid.items2.a0 = "valid_icon_show";
      } else if (item.items2.a0 != null) {
        this.valid.items2.a0 = "valid_icon_hide";
      }
      if (item.items2.a1 == null || item.items2.a1.length == 0) {
        this.valid.items2.a1 = "valid_icon_show";
      } else if (item.items2.a1 != null) {
        this.valid.items2.a1 = "valid_icon_hide";
      }
      if (item.items2.a2 == null || item.items2.a2.length == 0) {
        this.valid.items2.a2 = "valid_icon_show";
      } else if (item.items2.a2 != null) {
        this.valid.items2.a2 = "valid_icon_hide";
      }
      if (item.items2.a3 == null || item.items2.a3.length == 0) {
        this.valid.items2.a3 = "valid_icon_show";
      } else if (item.items2.a3 != null) {
        this.valid.items2.a3 = "valid_icon_hide";
      }
      if (item.items2.a4 == null || item.items2.a4.length == 0) {
        this.valid.items2.a4 = "valid_icon_show";
      } else if (item.items2.a4 != null) {
        this.valid.items2.a4 = "valid_icon_hide";
      }
      if (item.items2.a5 == null || item.items2.a5.length == 0) {
        this.valid.items2.a5 = "valid_icon_show";
      } else if (item.items2.a5 != null) {
        this.valid.items2.a5 = "valid_icon_hide";
      }
      if (item.items2.a6 == null || item.items2.a6.length == 0) {
        this.valid.items2.a6 = "valid_icon_show";
      } else if (item.items2.a6 != null) {
        this.valid.items2.a6 = "valid_icon_hide";
      }
      // slot 3
      if (item.items3.a0 == null || item.items3.a0.length == 0) {
        this.valid.items3.a0 = "valid_icon_show";
      } else if (item.items3.a0 != null) {
        this.valid.items3.a0 = "valid_icon_hide";
      }
      if (item.items3.a1 == null || item.items3.a1.length == 0) {
        this.valid.items3.a1 = "valid_icon_show";
      } else if (item.items3.a1 != null) {
        this.valid.items3.a1 = "valid_icon_hide";
      }
      if (item.items3.a2 == null || item.items3.a2.length == 0) {
        this.valid.items3.a2 = "valid_icon_show";
      } else if (item.items3.a2 != null) {
        this.valid.items3.a2 = "valid_icon_hide";
      }
      if (item.items3.a3 == null || item.items3.a3.length == 0) {
        this.valid.items3.a3 = "valid_icon_show";
      } else if (item.items3.a3 != null) {
        this.valid.items3.a3 = "valid_icon_hide";
      }
      // slot 4
      if (item.items4.a0 == null || item.items4.a0.length == 0) {
        this.valid.items4.a0 = "valid_icon_show";
      } else if (item.items4.a0 != null) {
        this.valid.items4.a0 = "valid_icon_hide";
      }
      console.log(count);
      if (count >= 22) {
        return true;
      }
    },
    submit_value(item) {
      let state = this.check_valid(item);
      if (state == true) {
        console.log('send feedback');
        try {
          this.$API
            .post("forms-add", item)
            .then((result) => {
              console.log(result);
              if (result.data.status == true) {
                // this.realtime();
                this.$vs.notify({
                  title: "Form",
                  text: "Successful!",
                  color: "success",
                  position: "top-center",
                  icon: "check",
                });
                this.toOverview();
              } else if (result.data.status == false) {
                // this.realtime();
                this.$vs.notify({
                  title: "Update Status was unsuccessful",
                  text: "Something wrong.",
                  color: "danger",
                  position: "top-center",
                  icon: "clear",
                });
              }
            })
            .catch((err) => {
              if (err) {
                // this.realtime();
                this.$vs.notify({
                  title: "Update Status was unsuccessful",
                  text: "Something wrong.",
                  color: "danger",
                  position: "top-center",
                  icon: "clear",
                });
                // this.popupActivo = false;
              }
            });
        } catch (error) {
          this.$vs.notify({
            title: "Update Status was unsuccessful",
            text: "Something wrong.",
            color: "danger",
            position: "top-center",
            icon: "clear",
          });
        }
      }
        console.log('not send feedback');

    },
    toOverview() {
      this.$router.push({ path: "/IndoorOverview" });
    },
    hidediv() {
      document.getElementById("print_form").style.display = "none";
    },
    printmodal() {
      document.getElementById("printHere").style.width = "100%";
      const modal = document.getElementById("printHere");

      const cloned = modal.cloneNode(true);
      let section = document.getElementById("print_form");

      if (!section) {
        section = document.createElement("div");
        section.id = "print_form";
        document.body.appendChild(section);
      }

      section.innerHTML = "";
      section.appendChild(cloned);
      window.print();
      location.reload();
      return false;
    },
  },
};
</script>
<style >
@media print {
  @page {
    size: portrait;
  }
  body * {
    visibility: hidden;
  }
  #print_form,
  #print_form * {
    visibility: visible;
  }
  #print_form {
    position: absolute;
    left: 0;
    width: 100%;
    top: 2.5%;
    -webkit-print-color-adjust: exact !important;
  }
}
</style>
<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Charm:wght@700&family=Sarabun&display=swap");
.fontthai {
  font-family: "Sarabun", sans-seri;
}
.valid_icon_hide {
  display: none;
}
.valid_icon_show {
  display: inline;
}
.text_box {
  width: 100%;
  position: relative;
  height: 200px;
  -webkit-box-shadow: 0 0 0 0 transparent;
  box-shadow: 0 0 0 0 transparent;
  border-radius: 6px;
  -webkit-transition: boxShadow 0.25s ease, border 0.25s ease,
    -webkit-transform 0.25s ease;
  transition: boxShadow 0.25s ease, border 0.25s ease,
    -webkit-transform 0.25s ease;
  transition: boxShadow 0.25s ease, border 0.25s ease, transform 0.25s ease;
  transition: boxShadow 0.25s ease, border 0.25s ease, transform 0.25s ease,
    -webkit-transform 0.25s ease;
  -webkit-transform: translate(0);
  transform: translate(0);
  margin-bottom: 16px;
}
.inside_txt {
  resize: none;
  border-radius: 6px;
  border: 0 solid transparent;
  display: block;
  padding: 9px;
  color: rgba(0, 0, 0, 0.8);
  font-size: 0.8rem;
  width: 100%;
  max-width: 100%;
  min-width: 100%;
  background: transparent;
}
.valid_text_show {
  border: 2px solid rgba(206, 206, 206, 0.76);
  border-radius: 5px;
  background-color: var(--background-color-sidebar);
  width: 100%;
  height: 200px;
  color: var(--text-color);
  padding: 0.5rem;
}
.valid_text_hide {
  border: 1px solid rgba(0, 0, 0, 0.08);
}
.colorgray {
  color: var(--text-color-2);
}
.div_row {
  display: flex;
  width: 100%;
}
.item_row {
  display: flex;
  align-items: center;
}
.div_p {
  padding: 0 10px;
  width: 100%;
}
.div_ptable {
  padding: 0 25% 0 5%;
  width: 100%;
}
.div_row_detail {
  padding: 0 20px;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}
.div_card {
  width: 100%;
  padding: 15px;
  height: auto;
  background: var(--background-color-sidebar);
  border-radius: 30px;
  display: block;
  -webkit-box-shadow: 0 4px 25px 0 rgb(0 0 0 / 10%);
  box-shadow: 0 4px 25px 0 rgb(0 0 0 / 10%);
  -webkit-transition: all 0.3s ease;
  transition: all 0.3s ease;
}
.nowrap {
  white-space: nowrap;
}
.num_center {
  width: 100%;
  text-align: center;
}
.div_item1 {
  width: 30%;
}
.div_item2 {
  width: 30%;
  margin-left: 1.5rem;
}
.div_item3 {
  width: 30%;
  margin-left: 1.5rem;
}
.div_item4 {
  width: 30%;
}
.div_item5 {
  width: 60%;
  margin-left: 1.5rem;
  flex-wrap: wrap;
}
.margin_top {
  margin-top: 0.5rem;
}
.text_right {
  text-align: right;
  padding-right: 27%;
}
.width45 {
  width: 45%;
}
.btnwidth {
  width: 120px;
  border-radius: 20px;
}
@media only screen and (max-width: 1000px) {
  /* .bg {
    background-color: lightblue;
  } */
  .div_item1 {
    width: 100%;
    margin-top: 8px;
  }
  .div_item2 {
    width: 100%;
    margin-left: 0;
    margin-top: 8px;
  }
  .div_item3 {
    width: 100%;
    margin-left: 0;
    margin-top: 8px;
  }
  .div_item4 {
    width: 100%;
    margin-top: 8px;
  }
  .div_item5 {
    width: 100%;
    margin-left: 0;
    margin-top: 8px;
  }
  .margin_top {
    margin-top: 0;
  }
  .div_ptable {
    padding: 0;
    width: 100%;
    margin-top: 15px;
  }
  .text_right {
    padding-right: 0;
  }
}
</style>